var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOperator = function SvgOperator(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#operator_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    x: 12,
    y: 10,
    fill: "#fff",
    rx: 10,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 19,
    height: 19,
    x: 12.5,
    y: 10.5,
    stroke: "#329DFF",
    strokeOpacity: 0.3,
    rx: 9.5,
    shapeRendering: "crispEdges"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#329DFF",
    clipPath: "url(#operator_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.597 20.439c.482-.047.801.146.887.651.029.169-.055.425-.165.556-.153.183-.316.365-.475.546l-1.023 1.17-.886 1.013c-.104.117-.187.234-.3.345-.574.564-1.267.504-2.019.504H20.39c-.279 0-.584-.009-.858.023-.112.07-.307.306-.414.41-.094.094-.129.126-.24.21-.597-.563-1.178-1.158-1.773-1.724-.106-.1-.495-.507-.585-.557.083-.133.28-.313.395-.426q.183-.18.364-.363c.12-.136.355-.347.488-.485.467-.485.92-.941 1.6-1.101a2.7 2.7 0 0 1 1.36-.002c.245.066.463.174.722.18.745.014 1.5-.02 2.244.013.186.008.443.202.526.368a.79.79 0 0 1-.026.722c-.233.393-.673.354-1.063.353l-.667-.001c-.313.002-.66-.01-.542.427a.43.43 0 0 0 .271.116c.196.012.398.008.595.004.325-.005.659.022.981-.024.39-.03.941-.442 1.03-.834.108-.467.09-.418.424-.79l.478-.533c.205-.224.405-.484.64-.675a.54.54 0 0 1 .258-.096M22.628 14.12c.835-.055.76.081.908.777.144.096.476.224.643.275.133-.098.356-.285.51-.325.259-.066.464.181.621.345.263.275.141.515-.059.77-.037.047-.084.134-.124.19.08.126.203.46.227.606.203.053.494.056.669.167.218.139.192.774.065.963-.13.194-.5.18-.723.22a8 8 0 0 1-.242.625c.13.213.442.52.295.79-.083.151-.376.436-.536.5-.248.1-.499-.207-.73-.314-.218.087-.392.142-.61.247-.09.289-.04.722-.433.782-.815.07-.8-.11-.91-.817-.143-.027-.457-.154-.626-.205-.42.174-.573.573-1.023.086-.099-.107-.253-.197-.28-.358-.05-.292.177-.514.336-.733-.102-.146-.198-.426-.239-.6-.198-.075-.449-.037-.637-.146-.19-.114-.175-.334-.178-.522-.005-.222.008-.333.125-.523.216-.107.443-.11.681-.156.075-.27.13-.37.247-.624-.166-.227-.459-.495-.305-.794.07-.136.364-.43.51-.486.285-.106.51.192.764.312q.044-.019.087-.04c.166-.077.34-.132.514-.19.107-.35.003-.737.453-.822m.327 4.445a1.135 1.135 0 1 0-.188-2.262 1.135 1.135 0 0 0 .188 2.262"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "operator_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M16 14h12v12H16z"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "operator_svg__a",
    width: 44,
    height: 44,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 2,
    result: "effect1_dropShadow_7805_68720"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.478431 0 0 0 0 0.227451 0 0 0 0 1 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7805_68720"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_7805_68720",
    result: "shape"
  })))));
};
export default SvgOperator;